import { PortalPage, Section } from "../../components/portal/PortalPage";
import PortalKnowledgeBase from "../../components/PortalKnowledgeBase";

const ROLE_MATRIX = [
  ["View jobs, requests, calendar, invoices, files", 1, 1, 1],
  ["Raise requests & emergencies, upload photos", 1, 1, 0],
  ["Comment & message the team", 1, 1, 0],
  ["Manage properties", 1, 1, 0],
  ["Book, move & cancel contract visits; rate visits", 1, 1, 0],
  ["Approve / decline quotes", 1, 0, 0],
  ["Confirm invoice payments", 1, 0, 0],
  ["Invite & manage team", 1, 0, 0],
];

export default function ClientHelpPage() {
  return (
    <PortalPage title="Help" subtitle="Step-by-step guides for everything in your client portal. Search, read, and tell us if a guide helped." testid="client-help">
      <PortalKnowledgeBase
        role="client"
        testIdPrefix="client-help"
        placeholder="Search help — e.g. book a visit, PO number, emergency…"
        intro={{ title: "Client portal guides", text: "Raising work, following jobs, managing contract visits, approving quotes, paying invoices and looking after your properties and team." }}
      />
      <Section title="Roles at a glance" className="mt-6" testid="client-help-roles">
        <table className="w-full text-xs">
          <thead><tr className="text-[10px] uppercase tracking-wider text-muted-foreground text-left"><th className="py-1">Action</th><th className="py-1 text-center">Admin</th><th className="py-1 text-center">User</th><th className="py-1 text-center">Viewer</th></tr></thead>
          <tbody className="divide-y divide-border">
            {ROLE_MATRIX.map(([a, ...c]) => (
              <tr key={a}><td className="py-1.5">{a}</td>{c.map((v, i) => <td key={i} className="py-1.5 text-center">{v ? "✓" : "—"}</td>)}</tr>
            ))}
          </tbody>
        </table>
      </Section>
    </PortalPage>
  );
}
